<script>
  import {mapState, mapActions, mapGetters} from 'vuex'

  export default {
    props: {
      value: Number,
      operation: Number,
      disabled: Boolean,
      disabledItems: {
        type: Array,
        default: () => [],
      },
      reservation: {
        type: Boolean,
        default: false,
      },
      allow: {
        type: Boolean,
        default: false,
      },
      hiddenClient: {
        type: Boolean,
        default: false,
      },
      hiddenOperator: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        v: this.value,
      }
    },
    methods: {
      change(v) {
        this.$emit('change', v)
      },
      disabled_item(i) {
        return this.disabledItems.indexOf(i) >= 0;
      },
    },
    computed: {
      ...mapGetters({
        list: 'dictionary/contragentType/list',
      }),
      items() {
        return this.list(this.operation, this.reservation, this.allow).filter(i => {
          if (this.hiddenClient && (i.value === 1 || i.value === 2)) return false;
          if (this.hiddenOperator && (i.value === 3)) return false;
          return true;
        })
      }
    },
    watch: {
      value(v) {
        this.v = v;
      }
    },
    components: {},
    mounted() {

    },
    destroyed() {

    },
  }
</script>
<template>
  <div class="input-contragent-type">
    <el-radio-group v-model="v" :disabled="disabled" @change="change">
      <el-radio-button class="input-contragent-type__title" :label="0" disabled>Тип контрагента:</el-radio-button>
      <el-radio-button v-for="item in items" :key="item.value" :label="item.value" :disabled="disabled_item(item.value)">{{item.value===7&&hiddenClient?'Расчет с Субагентом':item.label}}</el-radio-button>
    </el-radio-group>
  </div>
</template>
<style lang="scss">
  .input-contragent-type {
    .input-contragent-type__title {
      .is-active {
        .el-radio-button__inner {
          box-shadow: none;
          border: 1px solid #d8dce5;
        }
      }
      .el-radio-button__inner {
        width: 181px;
        background-color: #f5f7fa;
        color: #878d99;
        border: 1px solid #d8dce5;
        text-align: right;
        padding-right: 20px;
        cursor: default;
      }
    }

    .el-radio-button:first-child .el-radio-button__inner {
      color: #333 !important;
    }
  }
</style>
